import LzSideMenu from './side-menu.vue';
export default LzSideMenu;
